import { Collapse } from '../../collapse';
import { Flex } from '../../flex';
import type { ErrorDetailsData } from '../types';
import { ErrorReportContent } from './error-report-content';
import { useGetCollapseItems, useGetEnvironmentItems } from './hooks';

type P = {
  details: ErrorDetailsData;
};

const ErrorDetailsContent = ({ details }: P) => {
  const { errors } = details;

  const collapseItems = useGetCollapseItems({ details });
  const environmentItems = useGetEnvironmentItems({ details });

  return (
    <Flex gap="md" vertical>
      {errors.map((report, index) => (
        <ErrorReportContent
          environmentItems={environmentItems}
          // eslint-disable-next-line react/no-array-index-key -- This will create unique keys
          key={`${report.errorSummary.name}-${index}`}
          report={report}
          title={errors.length > 1 ? `Error ${index + 1} of ${errors.length}` : undefined}
        />
      ))}
      {collapseItems.length > 0 ? <Collapse items={collapseItems} /> : null}
    </Flex>
  );
};

export default ErrorDetailsContent;
